module.exports = __webpack_public_path__ + "img/search2.0831d712.png";